import { createContext } from "react";

export const CartContext = createContext(null);

/*
Context API's are one of the ways of sharing the data between different components,
for production level - we use Redux 
 */